import Config from "@Config";
import { pubsub } from "@utils";

window.googleMapsLoaded = () => {
    pubsub.publish("googleMapsAPILoaded");
};

// async script include
let gMapsJs = document.createElement("script");
gMapsJs.type = "text/javascript";
gMapsJs.async = true;
gMapsJs.src = `https://maps.googleapis.com/maps/api/js?key=${Config.googleMapsAPIKey}&libraries=places&callback=window.googleMapsLoaded`;
if (document && document.body) document.body.appendChild(gMapsJs);

// dev key
// AIzaSyAN1PmHA-V4E-NLfRe-MGQidXXEjoSTLiQ

// prod key
// AIzaSyCfZJKQLckaY6nrCBMEbBbepbUHeRoQsbY
